export default __webpack_public_path__ + "static/media/locker.ddd5bc84.png";